var map = {
	"./de/impressum.mdx": 46897,
	"./de/index.mdx": 62095,
	"./de/rechtliche-grundlagen.mdx": 60819,
	"./en/imprint.mdx": 19621,
	"./en/index.mdx": 54201,
	"./en/legal-framework.mdx": 83767,
	"./fr/cadre-juridique.mdx": 32148,
	"./fr/impressum.mdx": 70249,
	"./fr/index.mdx": 42586,
	"./it/colophon.mdx": 3865,
	"./it/index.mdx": 73377,
	"./it/quadro-giuridico.mdx": 65961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 46549;
module.exports = webpackContext;